import {PRODUCTS_URL, PRODUCTS_GROUP, CATEGORY_URL, CATEGORY_2_URL} from './url';

const apiMap = Object.freeze({
  product: PRODUCTS_URL,
  group: `${PRODUCTS_GROUP}/`,
  category: CATEGORY_URL, 
  category2: CATEGORY_2_URL
});

export const getExportApi = type => Object.prototype.hasOwnProperty.call(apiMap, type)
  ? apiMap[type]
  : undefined;



// WEBPACK FOOTER //
// ./src/api/downloadApi.js